<template>
  <v-card color="grey-lighten-4">
    <v-card-title>
      <h2 class="text-h2">{{ $t('L_new_york_state_domestic_and_sexual_violence') }}</h2>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-row class="pt-2">
        <v-col
          cols="10"
          offset="1"
          sm="6"
          offset-sm="0"
          offset-md="1"
          md="5"
          offset-lg="2"
          lg="4"
          class="pa-3 pb-2"
        >
          <h5 class="text-h5 font-weight-medium">
            {{ $t('L_english') }}
          </h5>
          <a :href="`tel:+` + $t('L_hotline')">
            <h4 class="text-h4">
              <v-icon size="22px" color="primary" class="mr-2" :icon="mdiPhone" />
              <span>{{ $t('L_hotline') }}</span>
            </h4>
          </a>
        </v-col>
        <v-col
          cols="10"
          offset="1"
          sm="6"
          offset-sm="0"
          offset-md="1"
          md="5"
          offset-lg="2"
          lg="4"
          pa-3
          pb-0
        >
          <h5 id="text-h5-ny" class="text-h5 font-weight-medium">
            {{ $t('L_in_nyc') }}
          </h5>
          <h4 class="text-h4">
            <v-icon size="22px" color="primary" class="mr-2" :icon="mdiPhone" />
            <a :href="`tel:+` + $t('L_hope_no')" class="font-weight-regular">
              <span>{{ $t('L_hope') }}</span>
            </a>
            <br />
            <span class="pl-4 ml-2">
              or
              <a :href="`tel:+` + $t('L_dial_311_no')" class="font-weight-regular">
                <span>{{ $t('L_dial_311') }}</span>
              </a>
            </span>
          </h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="10"
          offset="1"
          sm="6"
          offset-sm="0"
          offset-md="1"
          md="5"
          offset-lg="2"
          lg="4"
          pa-3
          pb-0
        >
          <h5 id="text-h5-spanish" class="text-h5 font-weight-medium">
            {{ $t('L_spanish') }}
          </h5>
          <a :href="`tel:+` + $t('L_spanish_no')">
            <h4 class="text-h4">
              <v-icon size="22px" color="primary" class="mr-2" :icon="mdiPhone" />
              <span>{{ $t('L_spanish_no') }}</span>
            </h4>
          </a>
        </v-col>
        <v-col
          cols="10"
          offset="1"
          sm="6"
          offset-sm="0"
          offset-md="1"
          md="5"
          offset-lg="2"
          lg="4"
          pa-3
          pb-0
        >
          <h5 class="text-h5 font-weight-medium">
            {{ $t('L_tty') }}
          </h5>
          <a :href="`tel:+` + $t('L_in_nyc_no')">
            <h4 class="text-h4">
              <v-icon size="22px" color="primary" class="mr-2" :icon="mdiPhone" />
              <span>{{ $t('L_in_nyc_no') }}</span>
            </h4>
          </a>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="10"
          offset="1"
          sm="6"
          offset-sm="0"
          offset-md="1"
          md="5"
          offset-lg="2"
          lg="4"
          pa-3
          pb-0
        >
          <h5 class="text-h5 font-weight-medium">
            {{ $t('L_deaf_hoh') }}
          </h5>
          <a :href="`tel:+` + $t('L_deaf_no')">
            <h4 id="deaf-no" class="text-h4">
              <v-icon size="22px" color="primary" class="mr-2" :icon="mdiPhone" />
              <span>{{ $t('L_deaf_no') }}</span>
            </h4>
          </a>
        </v-col>
        <v-col
          cols="10"
          offset="1"
          sm="6"
          offset-sm="0"
          offset-md="1"
          md="5"
          offset-lg="2"
          lg="4"
          pa-3
          pb-0
        />
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script lang="ts">
import { mdiPhone } from '@mdi/js';
import { defineComponent, type ComponentOptions } from 'vue';

const componentOptions: ComponentOptions = {
  name: 'ViewContactDetails',
  data: () => ({
    mdiPhone,
  }),
};

export default defineComponent(componentOptions);
</script>
